import './App.css';
import LandingPage from './components/LandingPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Main from './components/Main';
import LoginPage from './components/LoginPage';
import SignupPage from './components/SignupPage';
import TaskAcceptance from './components/TaskAcceptance';
import RequireAuth from './components/RequireAuth';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ConfirmEmailChange from './components/ConfirmEmailChange';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Contact from './components/Contact';
import FlowsynSetup from './components/Flowsync/FlowsyncSetup';
import FlowSyncDashboard from './components/Flowsync/FlowsyncDashboard';
import FlowSyncArchive from './components/Flowsync/FlowsyncArchive';
import FlowSyncHistory from './components/Flowsync/FlowsyncHistory';
import BetaGate from './components/Flowsync/BetaGate';
import AdminPanel from './components/Admin/AdminPanel';
function App() {

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/home' exact element={ <RequireAuth><Main/></RequireAuth>}/>
          <Route path='/' exact element={<LandingPage/>}/>
          <Route path='/login' exact element={<LoginPage/>}/>
          <Route path='/signup' exact element={<SignupPage/>}/>
          <Route path='/terms' exact element={<Terms/>}/>
          <Route path='/privacy' exact element={<Privacy/>}/>
          <Route path='/contact' exact element={<Contact/>}/>
          <Route path='/forgot-password' exact element={<ForgotPassword/>}/>
          <Route path='/reset-password' exact element={<ResetPassword/>}/>
          <Route path='/confirm-email-change' exact element={<ConfirmEmailChange/>}/>
          <Route path='/accept-task' exact element={<RequireAuth><TaskAcceptance/></RequireAuth>}/>
          <Route path='/flowsync-beta' exact element={<RequireAuth><BetaGate/></RequireAuth>}/>
          <Route path='/flowsync-setup' exact element={<RequireAuth><FlowsynSetup/></RequireAuth>}/>
          <Route path='/flowsync' exact element ={<RequireAuth><FlowSyncDashboard/></RequireAuth>}/>
          <Route path='/flowsync/archive' exact element ={<RequireAuth><FlowSyncArchive/></RequireAuth>}/>
          <Route path='/flowsync/history' exact element ={<RequireAuth><FlowSyncHistory/></RequireAuth>}/>
          <Route path='/flowman-admin' exact element={<RequireAuth><AdminPanel/></RequireAuth>}/>
        </Routes>

        </Router>
    

    </div>
  );
}

export default App;
